var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5619_7647)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.625 6.16683C2.625 6.55641 2.94375 6.87516 3.33333 6.87516C3.72292 6.87516 4.04167 6.55641 4.04167 6.16683V4.75016H5.45833C5.84792 4.75016 6.16667 4.43141 6.16667 4.04183C6.16667 3.65225 5.84792 3.3335 5.45833 3.3335H4.04167V1.91683C4.04167 1.52725 3.72292 1.2085 3.33333 1.2085C2.94375 1.2085 2.625 1.52725 2.625 1.91683V3.3335H1.20833C0.81875 3.3335 0.5 3.65225 0.5 4.04183C0.5 4.43141 0.81875 4.75016 1.20833 4.75016H2.625V6.16683Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.70801 12.5415C10.8816 12.5415 11.833 11.5901 11.833 10.4165C11.833 9.2429 10.8816 8.2915 9.70801 8.2915C8.5344 8.2915 7.58301 9.2429 7.58301 10.4165C7.58301 11.5901 8.5344 12.5415 9.70801 12.5415Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.375 4.75016H13.1296L12.2513 3.79391C12.1192 3.64898 11.9585 3.53318 11.7792 3.4539C11.5999 3.37463 11.406 3.33362 11.21 3.3335H6.67667C6.79708 3.546 6.875 3.77975 6.875 4.04183C6.875 4.821 6.2375 5.4585 5.45833 5.4585H4.75V6.16683C4.75 6.946 4.1125 7.5835 3.33333 7.5835C3.07125 7.5835 2.8375 7.50558 2.625 7.38516V14.6668C2.625 15.446 3.2625 16.0835 4.04167 16.0835H15.375C16.1542 16.0835 16.7917 15.446 16.7917 14.6668V6.16683C16.7917 5.38766 16.1542 4.75016 15.375 4.75016ZM9.70833 13.9585C7.75333 13.9585 6.16667 12.3718 6.16667 10.4168C6.16667 8.46183 7.75333 6.87516 9.70833 6.87516C11.6633 6.87516 13.25 8.46183 13.25 10.4168C13.25 12.3718 11.6633 13.9585 9.70833 13.9585Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5619_7647"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraPlus);
export default __webpack_public_path__ + "static/media/cameraPlus.7392797491c5a862eac588401e4be95a.svg";
export { ForwardRef as ReactComponent };